function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M3.75 3.75H2.25C1.90126 3.75 1.72689 3.75 1.58383 3.78833C1.1956 3.89236 0.892359 4.1956 0.788333 4.58383C0.75 4.72689 0.75 4.90126 0.75 5.25C0.75 5.94748 0.75 6.29622 0.826667 6.58234C1.03472 7.3588 1.6412 7.96528 2.41766 8.17333C2.70378 8.25 3.05252 8.25 3.75 8.25M14.25 3.75H15.75C16.0987 3.75 16.2731 3.75 16.4162 3.78833C16.8044 3.89236 17.1076 4.1956 17.2117 4.58383C17.25 4.72689 17.25 4.90126 17.25 5.25C17.25 5.94748 17.25 6.29622 17.1733 6.58234C16.9653 7.3588 16.3588 7.96528 15.5823 8.17333C15.2962 8.25 14.9475 8.25 14.25 8.25M9 10.5V13.5",
  stroke: "#1B1C1C",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.75 4.875C3.75 3.82663 3.75 3.30245 3.92127 2.88896C4.14963 2.33765 4.58765 1.89963 5.13896 1.67127C5.55245 1.5 6.07663 1.5 7.125 1.5H10.875C11.9234 1.5 12.4476 1.5 12.861 1.67127C13.4124 1.89963 13.8504 2.33765 14.0787 2.88896C14.25 3.30245 14.25 3.82663 14.25 4.875V5.25C14.25 6.64596 14.25 7.34394 14.0665 7.90881C13.6955 9.05046 12.8005 9.94552 11.6588 10.3165C11.0939 10.5 10.396 10.5 9 10.5C7.60404 10.5 6.90606 10.5 6.34119 10.3165C5.19954 9.94552 4.30448 9.05046 3.93354 7.90881C3.75 7.34394 3.75 6.64596 3.75 5.25V4.875Z",
  stroke: "#54606B",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6 15.6818C6 14.4768 6.97683 13.5 8.18182 13.5H9.81818C11.0232 13.5 12 14.4768 12 15.6818C12 16.1337 11.6337 16.5 11.1818 16.5H6.81818C6.36631 16.5 6 16.1337 6 15.6818Z",
  stroke: "#54606B",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcTrophyHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrophyHome);
export default __webpack_public_path__ + "static/media/ic_trophy_home.ed265766.svg";
export { ForwardRef as ReactComponent };